import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Z from './zuora';
import { getPaymentForm, zuoraCallback } from '../actions';
import withAccountInputs from '../containers/withAccountInputs';


export class PaymentForm extends React.Component {
  componentWillMount() {
    this.props.getPaymentForm(this.props.history);
  }

  componentDidUpdate() {
    if (this.props.paymentForm.dataLoaded) {
      Z.render(
        this.props.paymentForm.formParams,
        this.props.paymentForm.prepopulateFields,
        (response) => { this.props.zuoraCallback(response, this.props.history); },
      );
    }
  }

  render() {
    return (
      <div className="zuora-container">
        <div id="zuora_payment" data-role="zuora-payment" />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getPaymentForm: (history) => {
    dispatch(getPaymentForm(history));
  },
  zuoraCallback: (response, history) => {
    dispatch(zuoraCallback(response, history));
  },
});

function mapStateToProps({ paymentForm }) {
  return { paymentForm };
}

PaymentForm.propTypes = {
  getPaymentForm: PropTypes.func.isRequired,
  paymentForm: PropTypes.shape({
    dataLoaded: PropTypes.bool.isRequired,
    formParams: PropTypes.object,
    prepopulateFields: PropTypes.object,
  }).isRequired,
  zuoraCallback: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const ConnectedPaymentForm =
  withRouter(withAccountInputs(PaymentForm));

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConnectedPaymentForm);



// WEBPACK FOOTER //
// ./src/components/PaymentForm.jsx